"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/components/SignupStepControls.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _BackArrow = require('./BackArrow'); var _BackArrow2 = _interopRequireDefault(_BackArrow);










const OrgSurveyControls = ({
  onBack,
  onNext,
  isNextDisabled,
  isNextLoading,
  className,
  nextBtnLabel = 'Continue',
}) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, "signup-step--controls", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
    ,  onBack && _react2.default.createElement(_BackArrow2.default, { onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}} ) 
    , _react2.default.createElement(_Form.Button, {
      isSubmit: !onNext,
      isLoading: isNextLoading,
      isDisabled: isNextDisabled,
      className: "signup-step--controls--next-btn",
      onClick: onNext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}

      ,  nextBtnLabel 
    )
  )
)

exports. default = OrgSurveyControls
